<template>
  <div class="index-page">
    <div class="video-content">
      <div class="cover">
        <div
          class="content app-flex-column font-color-white"
          :style="{ top: videoCoverTextTop }"
        >
          <h2 class="font-46">在微博，发现更多精彩</h2>
          <h3 class="font-16 slogan">V-HALL ON WEIBO</h3>
          <div class="app-flex-row">
            <i class="iconfont icon-a-bianzu3"></i>
            <button
              v-stat:click="{ key: 'index_banner_video_click' }"
              class="btn font-color-white"
              @click="openVideo"
            >
              观看影片
            </button>
          </div>
        </div>
      </div>
      <video
        ref="keyVideoRef"
        src="https://static.hd.weibo.com/marketing/index-video-small.mp4?1633918999181"
        autoplay
        muted
        loop
        class="key-video"
      ></video>
    </div>
    <ul class="index-layout">
      <li
        v-for="item in layout"
        :key="item.name"
        class="item"
        :class="{ dark: item.theme === 'dark' }"
        :style="{
          background: item.bgColor
        }"
      >
        <div class="top app-flex-column app-basic-layout-wrapper">
          <h3 class="title font-30">{{ item.title }}</h3>
          <h4
            class="sub-title font-color-desc"
            :style="{ color: item.subColor || '' }"
          >
            {{ item.subTitle }}
          </h4>
          <p
            v-if="item.desc"
            class="desc"
            :style="{ color: item.subColor || '' }"
          >
            {{ item.desc }}
          </p>
        </div>
        <div
          class="content"
          :class="{ 'app-basic-layout-wrapper': !item.fullWidth }"
        >
          <component
            :is="item.component"
            :senior-list="seniorList"
            :originality-list="originalityList"
          ></component>
          <a
            v-if="item.moreBtnText"
            v-stat:click="{ key: item.statKey }"
            :href="item.moreLink"
            class="more-btn app-flex-row-center font-color-white"
            target="_blank"
          >
            {{ item.moreBtnText }}
            <i class="iconfont icon-youcefanhuijiantou"></i>
          </a>
        </div>
      </li>
    </ul>
    <modal-base v-if="popShow" @wrapper-click="closeVideo">
      <div class="pop-video" :class="{ fullscreen: fullscreen }">
        <m-video
          :view-file="viewFile"
          :auto-play="true"
          :muted="true"
          poster
          @fullscreen="fullScreenToggle"
        ></m-video>
      </div>
    </modal-base>
  </div>
</template>

<script>
import IndexProduct from './components/IndexProduct'
import IndexStar from './components/IndexStar'
import IndexOriginality from './components/IndexOriginality'
import IndexAdvantage from './components/IndexAdvantage'
import IndexSenior from './components/IndexSenior'
import IndexContactInfo from './components/IndexContactInfo'
import ModalBase from '@/components/common/ModalBase'
import { API_PATH } from '@/global/config'

export default {
  components: {
    MVideo: () => import('@/components/video/MVideo'),
    IndexProduct,
    IndexStar,
    IndexOriginality,
    IndexAdvantage,
    IndexSenior,
    IndexContactInfo,
    ModalBase
  },
  data() {
    return {
      seniorList: [],
      originalityList: { video: [], blog: [] },
      layout: [
        {
          name: 'product',
          title: '通过微博建立社会化品牌认知',
          subTitle:
            '微博月活用户5亿+，是一个承载了明星、社会、综艺、新时代、电竞、情感、汽车等多垂类兴趣人群的社会化舆论场',
          component: 'IndexProduct',
          bgColor: '#ffffff'
        },
        {
          name: 'star',
          title: '达人推广精选推荐',
          subTitle: '精选优质达人组合，覆盖营销全链路',
          component: 'IndexStar',
          bgColor: '#f4f5f7',
          moreBtnText: '找更多达人',
          moreLink: 'https://weirenwu.weibo.com',
          statKey: 'index_star_more_click'
        },
        {
          name: 'originality',
          title: '创意灵感',
          theme: 'dark',
          subTitle: '聚集微博优质创作内容，提供创作学习参考',
          component: 'IndexOriginality',
          bgColor: '#2c2c31',
          moreBtnText: '查看更多',
          moreLink: 'https://hd.weibo.com/originality/list?alk_from=P006_C070',
          statKey: 'index_originality_more_click'
        },
        {
          name: 'advantage',
          title: '微博营销平台优势',
          subTitle:
            '"与其他的平台不同，微博的舆论场是天然形成的，聚合的是大家真实关注的热点话题"',
          desc: '——  微博营销高级副总裁  葛景栋',
          subColor: '#363636',
          component: 'IndexAdvantage',
          bgColor: '#ffffff',
          fullWidth: true
        },
        {
          name: 'senior',
          title: '合作案例',
          subTitle: '查看与您类似的商家如何借助微博实现业务增长',
          subColor: '#363636',
          component: 'IndexSenior',
          bgColor: '#f4f5f7',
          moreBtnText: '查看更多',
          moreLink: 'https://hd.weibo.com/senior/list?alk_from=P006_C070',
          statKey: 'index_senior_more_click'
        },
        {
          name: 'contact',
          title: '通过微博营销获取更多客户',
          subTitle: '请留下您的联系方式，专属顾问会尽快与您联系',
          subColor: '#363636',
          component: 'IndexContactInfo',
          bgColor: '#ffffff'
        }
      ],
      viewFile: {
        src: 'https://static.hd.weibo.com/marketing/index-video.mp4?1633919112086'
      },
      fullscreen: false,
      popShow: false,
      videoCoverTextTop: '33.3%'
    }
  },
  created() {
    this.getSenior()
    this.getOriginality()
  },
  mounted() {
    this.$nextTick(() => {
      let video = this.$refs.keyVideoRef
      const videoHeight = video.offsetHeight
      this.videoCoverTextTop = (videoHeight / 3).toFixed() + 'px'
    })
  },
  methods: {
    fullScreenToggle(isFullscreen) {
      this.fullscreen = isFullscreen
    },
    openVideo() {
      this.$refs.keyVideoRef.pause()
      this.onPopShow()
    },
    closeVideo() {
      this.popShow = false
      this.$refs.keyVideoRef.play()
    },
    onPopShow() {
      this.popShow = true
    },
    async getSenior() {
      const { data } = await this.$http.get(API_PATH.alkSenior.recomm, {
        params: { pg: 1, pz: 4 }
      })
      this.seniorList = data || []
    },
    async getOriginality() {
      let videoData = []
      let blogData = []
      const videoTypeIds = ['25217', '27208']
      const blogTypeIds = ['27172,28750']
      let ids = [...videoTypeIds, ...blogTypeIds].join(',')
      const { data } = await this.$http.get(API_PATH.alkOriginality.listByIds, {
        params: { ids }
      })
      if (data) {
        data.forEach(item => {
          if (videoTypeIds.includes(item.id)) {
            videoData.push(item)
          } else {
            blogData.push(item)
          }
        })
      }
      this.originalityList = { video: videoData, blog: blogData }
    }
  }
}
</script>

<style lang="scss" scoped>
.index-page {
  width: 100%;

  .video-content {
    width: 100%;
    position: relative;
    .key-video {
      width: 100%;
      display: block;
    }
    .cover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding-top: 73px;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.65);
      z-index: 9;
      .content {
        width: 100%;
        position: absolute;
        margin-top: 73px;
        top: 33.3%;
        align-items: center;
        .slogan {
          margin: 24px 0 35px;
        }
        .btn {
          border: none;
          background: transparent;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  .index-layout {
    .item {
      padding-top: 64px;
      padding-bottom: 88px;
      .top {
        align-items: center;
        padding-bottom: 60px;
        .title {
          padding-bottom: 25px;
          margin-bottom: 28px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: 32px;
            height: 5px;
            background: $danger-color;
            border-radius: 2px;
          }
        }
        .desc {
          margin-top: 12px;
          align-self: flex-end;
          margin-right: 57px;
        }
      }
      .content {
        .more-btn {
          width: 224px;
          height: 48px;
          background: $text-color-primary;
          border-radius: 24px;
          margin: 0 auto;
          .iconfont {
            margin-left: 6px;
          }
        }
      }
      &.dark {
        .title,
        .sub-title {
          color: #ffffff;
        }
      }
    }
  }

  .pop-video {
    width: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    &.fullscreen {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
